export default __webpack_public_path__ + "static/media/instruction-active.b8b7c534.svg";